var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTaskListIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99854 3.99668L9.29908 2.37101C9.48916 2.13391 9.77628 1.99585 10.0804 1.99585H13.921C14.2251 1.99585 14.5122 2.13391 14.7023 2.37101L16.0019 3.99668V3.99668V4.9971C16.0019 5.54933 15.5537 5.99752 15.0015 5.99752H8.99895C8.44672 5.99752 7.99854 5.54933 7.99854 4.9971V3.99668V3.99668Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0034 11.9999V5.99742C20.0034 4.89195 19.108 3.99658 18.0025 3.99658H16.0017",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.99849 3.99658H5.99766C4.8922 3.99658 3.99683 4.89195 3.99683 5.99742V19.0028C3.99683 20.1083 4.8922 21.0037 5.99766 21.0037H12.0002",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9986 3.99658H17.9994C19.1049 3.99658 20.0002 4.89195 20.0002 5.99742V19.0028C20.0002 20.1083 19.1049 21.0037 17.9994 21.0037H11.9969",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.998 11.0002H15.998",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 9.5L7.9375 11.5L7 10.5909",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 16.5002H16",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 15L7.9375 17L7 16.0909",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaskListIcon);
export default __webpack_public_path__ + "static/media/task-list-icon.c1ccbc3a3b5d1a80df329206f98df91c.svg";
export { ForwardRef as ReactComponent };